import {TtTravelEntry} from '../../interfaces/time-tracking/tt-travel-entry';
import {Vehicle} from '../../interfaces/vehicles/vehicle';
import {VehicleFactory} from '../vehicles/vehicle-factory';
import {LightUser} from '../../interfaces/core/light-user';
import {LightUserFactory} from '../core/light-user-factory';
import {UserService} from '../../services/core/user.service';

export class TtTravelEntryFactory {

  /**
   *
   * @param ttTravelEntry
   */
  public static fromObject(ttTravelEntry: any): TtTravelEntry {
    return new class implements TtTravelEntry {
      date: string = ttTravelEntry.date;
      emEmploymentId: number = ttTravelEntry.em_employment_id;
      employeeId: number = ttTravelEntry.employee_id;
      foreignServiceFacilityId: number = ttTravelEntry.foreign_service_facility_id;
      isDividedWorkingTime: boolean = ttTravelEntry.is_divided_working_time;
      isExternalDriver: boolean = ttTravelEntry.is_external_driver;
      isPrivate: boolean = ttTravelEntry.is_private;
      mileageEnd: number = ttTravelEntry.mileage_end;
      mileageStart: number = ttTravelEntry.mileage_start;
      userId: number = ttTravelEntry.user_id;
      user: LightUser = ttTravelEntry.user ? LightUserFactory.fromObject(ttTravelEntry.user) : null;
      vehicle: Vehicle = ttTravelEntry.vehicle ? VehicleFactory.fromObject(ttTravelEntry.vehicle) : null;
      vehicleId: number = ttTravelEntry.vehicle_id;

      // ------------------------------------------------------------------------------------------------
      id: number = ttTravelEntry.id;
      uuid: string = ttTravelEntry.uuid;
      modified: string = ttTravelEntry.modified;
      created: string = ttTravelEntry.created;
      deleted: 0 | 1 = 0;
    };
  }

  /**
   *
   * @param ttTravelEntries
   */
  public static fromArray(ttTravelEntries: any[]): TtTravelEntry[] {
    return ttTravelEntries.map(TtTravelEntryFactory.fromObject);
  }

  /**
   *
   */
  public static new(ttTravelEntry: TtTravelEntry = null): TtTravelEntry {
    const _ttTravelEntry = new class implements TtTravelEntry {
      date: string = null;
      emEmploymentId: number = null;
      employeeId: number = null;
      foreignServiceFacilityId: number = null;
      isDividedWorkingTime: boolean = null;
      isExternalDriver: boolean = null;
      isPrivate: boolean = null;
      mileageEnd: number = null;
      mileageStart: number = null;
      userId: number = UserService.getUser().id;
      vehicle: Vehicle = null;
      vehicleId: number = null;
      user: LightUser = LightUserFactory.fromUser(UserService.getUser());

      // ------------------------------------------------------------------------------------------------
      id: number = null;
      uuid: string = null;
      modified: string = null;
      created: string = null;
      deleted: 0 | 1 = 0;
    };

    if(ttTravelEntry) {
      return {..._ttTravelEntry, ...ttTravelEntry};
    }

    return _ttTravelEntry;
  }

  /**
   *
   * @param ttTravelEntry
   */
  public static toRemote(ttTravelEntry: TtTravelEntry): any {
    return {
      id: ttTravelEntry.id,
      uuid: ttTravelEntry.uuid,
      date: ttTravelEntry.date,
      mileage_start: ttTravelEntry.mileageStart,
      mileage_end: ttTravelEntry.mileageEnd,
      is_private: ttTravelEntry.isPrivate,
      vehicle_id: ttTravelEntry.vehicleId,
      foreign_service_facility_id: ttTravelEntry.foreignServiceFacilityId,
      is_divided_working_time: ttTravelEntry.isDividedWorkingTime,
      is_external_driver: ttTravelEntry.isExternalDriver,
      em_employment_id: ttTravelEntry.emEmploymentId,
      employee_id: ttTravelEntry.employeeId
    };
  }

}
